export default __webpack_public_path__ + "static/media/kayaguneridort6.99503117.jpg";